import { ReactElement } from "react";

import { Link } from "@chakra-ui/next-js";

import { Product } from "@/__generated__/graphql";
import Register from "@/components/Register";
import LoginTwoPanelLayout from "@/layouts/LoginTwoPanelLayout";
import { pathTo } from "@/utils/pathGenerators";

function RegisterPage() {
  return <Register product={Product.Release} />;
}
export default RegisterPage;

RegisterPage.getLayout = (page: ReactElement) => {
  return (
    <LoginTwoPanelLayout
      rightPanel="environmentsAsAService"
      secondaryAction={
        <>
          Have an account? <Link href={pathTo("/login", { keepQuery: true })}>Sign in</Link>
        </>
      }
    >
      {page}
    </LoginTwoPanelLayout>
  );
};
